export class Specialisation {
    public id: number;
    public locationId: number;
    public systemId: number;
    public name: string;
    public isChanged: boolean;
}